import { ExprUtils } from './ExprUtils';
import { StringUtils } from './StringUtils';

export class EntityUtils {
  /** Checks entity statuses to see if an entity can be validated */
  static isValidatable(entityObj) {
    let entityStatus = entityObj.status;
    return ['DRAFT', 'ACTIVE', 'ERROR'].includes(entityStatus)
  }

  /** Checks entity statuses to see if an entity can be sent for approval */
  static isApprovable(entityObj) {
    let entityStatus = entityObj.status;
    let entityValStatus = entityObj.valStatus;
    return (['DRAFT'].includes(entityStatus) && (['VALID', 'WARN'].includes(entityValStatus)));
  }

  /** Checks entity statuses to see if an entity can be approved. Also checks if there is an Approval Event for this user (supplied by userApprovableEntityIds) */
  static isUserApprovable(entityObj, userApprovableEntityIds) {
    let entityStatus = entityObj.status;
    let entityValStatus = entityObj.valStatus;

    return (['APPROVING'].includes(entityStatus) && (['VALID', 'WARN'].includes(entityValStatus)) && userApprovableEntityIds.includes(entityObj.id));
  }

  static filterAuthorizedFields = (module, entity, fieldDefs, getFieldRoleSet) => {
  
    const viewFieldCodes = getFieldRoleSet(module, entity, 'VIEW');
    if (viewFieldCodes.size !== 0) {
      fieldDefs = fieldDefs.filter(fieldDef => {
        return fieldDef.isAudit || viewFieldCodes.has(StringUtils.toCodeConvention(fieldDef.field));
      });
    }
  
    // Assign Edit Level to NEVER if the principal is not authorized to SAVE
    const editFieldCodes = getFieldRoleSet(module, entity, 'SAVE');
    if (editFieldCodes.size !== 0) {
      fieldDefs.forEach(fieldDef => {
        if (!editFieldCodes.has(StringUtils.toCodeConvention(fieldDef.field))) {
          fieldDef.editLevel = 'NEVER';
        }
      });
    }
    return fieldDefs;
  }

  /*
  * Helper for generically adding optional parent id for an EntityList
  */
  static parentFilterAugRowsReq = (parentEntity, parentId) => {
    return (rowsReq) => {
      if (!parentId) {
        return rowsReq;
      }

      let expr = rowsReq.expr;
      rowsReq.expr = ExprUtils.and(expr, ExprUtils.whereParams(StringUtils.toLowerCamel(parentEntity) + 'Id', parentId));
    }
  }
}